<template>
  <v-container fluid grid-list-md class="pt-3 pl-0 pr-0">
    <v-progress-circular v-if="loading && (items == null || items.length == 0)" :size="150" :width="7" class="result_progress" indeterminate color="primary"></v-progress-circular>
    <draggable v-else v-model="items" class="layout results row wrap" style="min-width: 100%" :options="{group: { name:'role',  pull:'clone', put:false }, sort: false, disabled: true }">
      <v-flex v-for="(item, i) in items" xs12 md4 lg3 xl3 :class="$vuetify.breakpoint.smAndDown ? 'px-0' : null" :key="i">
        <v-card hover class="pa-0 ma-0">
          <v-img :src="getImageUrl(item, item.mainPhoto, 400)" eager @error="imageLoadError($event, item, i)" aspect-ratio="1.2" v-on:click="project ? showProfileDetail(item) : ($store.state.dialogs.profileDetail = { show: true, profile: item, noRefresh: true })" 
            :lazy-src="item.sex === 'woman' ?
            `data:image/svg+xml;base64,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` :
            `data:image/svg+xml;base64,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`
            ">
            <div style="float: left" v-if="search && project">
              <v-btn color="rgba(0,0,0,0.15)" small icon dark class="mt-2 ml-2" :class="!isItemChecked(i) && $vuetify.breakpoint.mdAndUp ? `show-on-hover` : ``" v-on:click.stop="checkItem(i)">
                <v-icon color="white">{{isItemChecked(i) ? `mdi-check-circle` : `mdi-checkbox-blank-circle-outline`}}</v-icon>
              </v-btn>
            </div>
            <div style="float: right" v-if="search">
              <v-btn color="rgba(0,0,0,0.15)" :class="$vuetify.breakpoint.mdAndUp ? `show-on-hover elevation-0` : `elevation-0`" small fab dark @click.stop="findSimilarFaces(item)" class="mt-2">
                <v-icon color="white">image_search</v-icon>
              </v-btn>
              <v-btn v-if="project" color="rgba(0,0,0,0.15)" :class="$vuetify.breakpoint.mdAndUp ? `show-on-hover elevation-0` : `elevation-0`" small fab dark @click.stop="dislikeProfile(item)" class="mt-2">
                <v-icon color="white">not_interested</v-icon>
              </v-btn>
              <v-btn v-if="project" color="rgba(0,0,0,0.15)" :class="($vuetify.breakpoint.mdAndUp && !item.liked) ? `show-on-hover elevation-0` : `elevation-0`" small fab dark class="mt-2 mr-2" @click.stop="likeProfile(item)">
                <v-icon color="white">{{item.liked ? `favorite` : `favorite_border`}}</v-icon>
              </v-btn>
            </div>
            <div style="float: right" v-else>
              <v-btn color="rgba(0,0,0,0.15)" :class="($vuetify.breakpoint.mdAndUp) ? `show-on-hover` : ``" small icon dark class="mr-2" @click.stop="removeProfile(i)">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </div>
            <div v-if="item.video || (item.videos && item.videos.length) || (item.showreel && item.showreel.length)" class="mt-4" style="position: absolute; bottom: 12px; left: 12px; opacity: 0.7">
              <div class="d-inline-block">
                <v-avatar color="white" :size="24"><v-icon :size="18" color="black">videocam</v-icon></v-avatar>
              </div>
            </div>
            <div style="clear: both"></div>
          </v-img>
          <v-card-title primary-title class="pa-3">
            <div style="width: 100%">
              <div style="width: 100%; font-size: 1.05em; font-weight: 400;">
                <div style="float: left">
                  <span>{{formatName(item.name)}}</span> 
                  <span v-if="item.dob && item.dob.age" class="grey--text text--lighten-1"> {{item.dob.age}}</span>
                </div>
                <div style="float: right">
                  <span v-if="item.height">{{item.height}} cm</span>
                </div>
                <div style="clear: both"></div>
              </div>
              <div class="mt-1 grey--text one-line-ellipsis">
                {{ item.location.city }} 
                <span v-if="item.location.city && item.tags && item.tags.length" class="grey--text text--lighten-2">&bull;</span> 
                {{ item.tags ? item.tags.join(', ') : `` }}</div>
              <div class="mt-1" style="width: 100%">
                <div style="float: left">
                  <v-chip v-if="item.categoryName && item.categoryName != 'noProfession'" color="white" class="mt-1 shadow-2">
                    <span class="black--text">{{$t(item.categoryName)}}</span>
                  </v-chip>
                  <v-menu bottom right offset-y v-if="admin">
                    <template v-slot:activator="{on}">
                      <v-chip v-on="on" color="white" class="mt-1 ml-2 shadow-2">
                        <v-icon v-if="!item.approveState" color="primary">mdi-star-off</v-icon>
                        <template v-else-if="item.approveState === 'approved'"><span style="font-size: 14px">{{ getRating(item) }}</span> <v-icon color="secondary" small>mdi-star</v-icon></template>
                        <v-icon v-else-if="item.approveState === 'declined'" color="error darken-1">mdi-account-off</v-icon>
                      </v-chip>
                    </template>
                    <v-card color="white" class="px-4 py-6">
                      <div v-if="item.approveState === 'declined'" style="font-size: 10px" class="text-center mb-2">Profil je zamítnutý,<br/>povolíte ho hodnocením.</div>
                      <div v-else-if="!item.approveState" style="font-size: 10px" class="text-center mb-2">Profil zatím nikdo nehodnotil.</div>
                      <v-rating v-if="item.rating" :value="getRating(item)" @input="setRating(item, $event)" class="d-inline-block" half-increments dense hover empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half"></v-rating>
                      <div class="text-center mt-3" v-if="item.approveState !== 'declined'">
                        <v-dialog v-model="declineDialog" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" small class="elevation-0"><v-icon left small color="error darken-1">mdi-account-off</v-icon> Zamítnout</v-btn>
                          </template>
                          <v-card>
                            <v-card-title>Opravdu chcete zamítnout tento profil?</v-card-title>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="error" text @click="declineProfile(item)">Zamítnout</v-btn>
                              <v-btn text @click="declineDialog = false">Storno</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                    </v-card>
                  </v-menu>
                </div>
                <div style="float: right">
                  <v-menu v-if="getRolesInt()" bottom right offset-y>
                    <template v-slot:activator="{on}">
                      <v-btn v-on="on" class="ma-0" icon>
                        <v-icon color="primary">add</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item v-for="role in getRolesInt()" :key="role.roleName" @click="addPickInt(item, role)">
                        <v-list-item-title>{{role.roleName}}</v-list-item-title>
                      </v-list-item>
                      <template v-if="allowAddingRoles">
                        <v-divider v-if="project && project.roles && project.roles.length"></v-divider>
                        <v-list-item @click="showRoleDialog(null)">
                          <v-list-item-title>{{$t('Events.addRole')}}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </draggable>
    <div class="text-center mt-3" v-if="search">
      <v-btn v-if="last && items != null && items.length > 0" :loading="loading" large @click="loadProfiles(last)" color="primary" class="elevation-0">{{$t('Results.showNextProfiles')}}</v-btn>
    </div>
    <v-dialog max-width="600" v-model="shareNameDialog" persistent>
      <v-card flat tile>
        <template v-if="shareURL">
          <v-card-text>
            <span style="font-size: 18px">{{$t('Event.urlToShare')}}</span>
            <v-text-field class="mt-4" v-model="shareURL" label="URL">
              <v-icon slot="append" @click="copyURL">{{copying ? `check` : `far fa-clipboard`}}</v-icon>
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="elevation-0" @click="shareNameDialog = false" color="primary">{{$t('closeOk')}}</v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-text>
            <span style="font-size: 18px">{{$t('ProfileMultiView.sharingName')}}</span>
            <v-text-field v-model="shareName" :label="$t('Files.name')"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="elevation-0" @click="shareProfiles()" color="primary">{{$t('ProfileMultiView.createLink')}}</v-btn>
            <v-btn class="elevation-0" @click="shareNameDialog = false">{{$t('cancel')}}</v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <v-alert :value="itemsSelected > 0" light color="#b3d4fc" class="bottom_alert black--text" transition="scroll-y-reverse-transition">
      <div class="d-inline-block" style="padding-left: 300px;">
        <v-avatar v-for="(selected, s) in selectedAvatars" :key="s" color="white" size="40" class="mr-1">
          <img v-if="selected.url" :src="selected.url">
          <template v-else>{{selected.count}}</template>
        </v-avatar>
      </div>
      <div class="button_row">
        <div class="content">
          <v-btn small fab  class="ml-1 mr-1 elevation-0" @click="dislikeSelected">
            <v-icon size="24" color="black">not_interested</v-icon>
          </v-btn>
          <v-btn small fab  class="ml-1 mr-1 elevation-0" @click="likeSelected">
            <v-icon size="24" color="black">favorite_border</v-icon>
          </v-btn>
          <v-btn small fab  class="ml-1 mr-1 elevation-0">
            <v-icon size="24" color="black" @click="shareNameDialog = true">share</v-icon>
          </v-btn>
          <v-menu v-if="getRolesInt()" top offset-y>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" small fab  class="ml-1 mr-1 elevation-0">
                <v-icon size="24" color="black">mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item v-for="role in getRolesInt()" :key="role.roleName" @click="addSelectedToRole(role)">
                <v-list-item-title>{{role.roleName}}</v-list-item-title>
              </v-list-item>
              <template v-if="allowAddingRoles">
                <v-divider v-if="project && project.roles && project.roles.length"></v-divider>
                <v-list-item color="primary" @click="showRoleDialog(null)">
                  <v-list-item-title>{{$t('Events.addRole')}}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
      <div class="close_alert">
        <v-btn icon @click="checkedItems = []">
          <v-icon color="black">close</v-icon>
        </v-btn>
      </div>
    </v-alert>
  </v-container>
</template>

<style>
.result_progress {
  position: absolute !important; 
  left: 50%; 
  top: 50%; 
  transform: translate(-50%, -50%)
}
.pane_expanded .result_progress {
  left: calc(50% + 150px); 
}
.show-on-hover {
  opacity: 0;
}
.v-card:hover .show-on-hover {
  opacity: 1;
}
.results .v-btn--right.v-btn--top.v-btn--absolute.v-btn--small.remove_profile {
  top: 4px;
  right: 4px;
}
.v-alert.bottom_alert {
  position: fixed; 
  width: 100%;
  min-height: 64px;
  bottom: 0px; 
  left: 0px; 
  margin: 0px; 
  padding: 10px 16px 10px 30px;
  z-index: 2;
}
#app.mobile .v-alert.bottom_alert {
  bottom: 56px;
}
.v-alert.bottom_alert .v-avatar {
  margin-left: -14px;
}

#app.mobile .v-alert.bottom_alert {
  padding: 10px 16px 10px 40px;
}
#app.mobile .v-alert.bottom_alert .v-avatar {
  margin-left: -24px;
}
.v-alert.bottom_alert .button_row {
  position: absolute;
  height: 60px;
  left: 0px; 
  bottom: 0px;
  width: 100%;
}
.pane_expanded .v-alert.bottom_alert .button_row {
  width: 100%;
}

.v-alert.bottom_alert .button_row .content {
  display: table;
  margin: 0 auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.v-alert.bottom_alert .close_alert {
  position: absolute; 
  height: 60px; 
  bottom: 0px;
  right: 64px;
}
.pane_expanded .v-alert.bottom_alert .close_alert {
  right: 80px;
}
.v-alert.bottom_alert .close_alert .v-btn {
  margin-top: 12px;
}
.one-line-ellipsis {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>

<script>
import * as api from '@/libs/api'
import { EventBus } from '@/libs/eventBus.js';
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SearchResults',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    search: {
      type: Boolean,
      default: () => true
    },
    searchFn: {
      type: Function,
      default: () => null
    },
    removeProfile: {
      type: Function,
      default: () => null
    },
    getRoles: {
      type: Function,
      default: null
    },
    addPick: {
      type: Function,
      default: null
    },
    allowAddingRoles: {
      type: Boolean,
      default: () => true
    },
  },
  data() {
    return {
      checkedItems: [],
      page: 1,
      loading: true,
      testImage: '',
      shareNameDialog: false,
      shareName: null,
      shareURL: null,
      copying: false,
      cat: [
        {icon: 'fa-theater-masks', name: 'Herec'},
        {icon: 'whatshot', name: 'Model'},
        {icon: 'fa-user-ninja', name: 'Kaskadér'},
        {icon: 'fa-street-view', name: 'Artista'},
        {icon: 'directions_walk', name: 'Tanečník'},
        {icon: 'fa-microphone-alt', name: 'Zpěvák'},
        {icon: 'fa-user-tie', name: 'Promotér'},
        {icon: 'accessibility_new', name: 'Moderátor'},
        {icon: 'fa-headset', name: 'Dabér'},
        {icon: 'fa-music', name: 'Muzikant'}
      ],
      declineDialog: false
    }
  },
  mounted: async function() {
    if (!this.value.length) {
      /*if (window.location.hash) {
        this.last = JSON.parse(atob(window.location.hash));
      }*/
      this.loadProfiles();
    }
  },
  computed: {
    items: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value); 
      }
    },
    project: function() {
      return this.getCurrentProject();
    },
    itemsSelected: function() {
      return this.checkedItems.length;
    },
    selectedAvatars: function() {
      let result = [];
      let count = 0
      let max = this.$vuetify.breakpoint.lgAndUp ? 10 : (this.$vuetify.breakpoint.mdAndUp ? 5 : 2);
      for (let item of this.checkedItems)
        if (++count <= max)
          result.push({url: this.getImageUrl(this.items[item], this.items[item].mainPhoto, 40)});

      if (count > max)
          result.push({count: '+' + (count - max)});

      return result;
    },
    last: {
      get: function() {
        return this.getLastSearch();
      },
      set: function(val) {
        this.setLastSearch(val);
        if (val) {
          window.location.hash = btoa(JSON.stringify(val));
        }
      }
    },
    admin() {
      return this.$store.state.user && this.$store.state.user.productionId && this.$store.state.user.productionId === 'ac076a32-454c-45c0-ba72-5d2c7b09f539';
    }
  },
  watch: {
    items: function(val) {
      this.$emit('input', val); 
    }
  },
  methods: {
    ...mapActions(['setLastSearch', 'addPickToCurrentProject', 'showProfileDetail', 'showRoleDialog'/*, 'likeProfile', 'dislikeProfile'*/]),
    ...mapGetters(['getLastSearch', 'getCurrentProject']),
    loadProfiles: async function(startKey) {
      this.loading = true;
      let {items, lastKey} = await this.searchFn(startKey);
      this.items.push(...items);
      this.last = lastKey ? lastKey : null;
      this.loading = false;
    },
    checkItem: function(i) {
      let index = this.checkedItems.findIndex(c => c == i);
      if (index > -1)
        this.checkedItems.splice(index, 1);
      else
        this.checkedItems.unshift(i);
    },
    isItemChecked: function(i) {
      return this.checkedItems.findIndex(c => c == i) > -1;
    },
    addSelectedToRole: function(role) {
      for (let selected of this.checkedItems) {
        this.addPickInt(this.items[selected], role);
        //this.addPickToCurrentProject({pick: this.items[selected], role: role});
      }
      this.checkedItems = [];
    },
    async likeProfile(profile) {
      if (profile.liked)
        profile.liked = false;
      else
        profile.liked = true;

      if (!this.$store.state.user.liked)
        this.$store.state.user.liked = [];

      let index = this.$store.state.user.liked.findIndex(userId => userId === profile.userId);

      if (index > -1) {
        this.$store.state.user.liked.splice(index, 1);
        await api.likeProfile(profile.userId, true);
      }
      else {
        this.$store.state.user.liked.push(profile.userId);
        await api.likeProfile(profile.userId, false);
      }
    },
    async dislikeProfile(profile) {
      if (!this.$store.state.user.disliked)
        this.$store.state.user.disliked = [];
      this.$store.state.user.disliked.push(profile.userId);

      let index = this.items.findIndex(p => p.userId == profile.userId);
      if (index > -1)
        this.items.splice(index, 1);
      this.$store.state.user.disliked.push(profile.userId);
      await api.dislikeProfile(profile.userId, false);
    },
    likeSelected: function() {
      for (let selected of this.checkedItems)
        this.likeProfile(this.items[selected]);
      this.checkedItems = [];
    },
    dislikeSelected: function() {
      let profiles = [];
      for (let selected of this.checkedItems)
        profiles.push(this.items[selected]);

      for (let profile of profiles)
        this.dislikeProfile(profile);
      this.checkedItems = [];
    },
    formatName(name) {
      if (!name)
        return "";
      
      name = name.trim();
      let parts = name.split(' ');
      if (parts.length < 2)
        return name;

      let letter = "";
      for (let i in parts) {
        if (i == 0)
          continue;
        let l = parts[i][0];
        if (typeof l == 'undefined')
          continue;
        
        letter = " " + l + ".";
      }
      return parts[0] + letter;
    },
    getImageUrl(user, filename, size) {
      return 'https://d3d0zdy5deiwj.cloudfront.net/fit-in/' + size +'x' + size + '/private/' + (user.manager || user.userId) + '/' + filename;
    },
    async shareProfiles() {
      let profiles = [];
      for (let selected of this.checkedItems)
        profiles.push(this.items[selected].userId);
      
      try {
        const shareId = await api.shareProfiles(this.shareName, profiles);
        this.shareURL = "https://prod.aircasting.cz/profiles/" + shareId;
      }
      catch (err) {
        console.error(err);
      }
    },
    copyURL() {
      this.copying = true;
      navigator.clipboard.writeText(this.shareURL);
      setInterval(()=>{this.copying = false}, 3000);
    },
    findSimilarFaces(profile) {
      EventBus.$emit('findSimilarFaces', profile);
    },
    getRolesInt() {
      if (this.getRoles != null)
        return this.getRoles();

      if (this.project)
        return this.project.roles;

      return [];
    },
    addPickInt(pick, role) {
      if (this.addPick != null) {
        return this.addPick(pick, role);
      }

      this.addPickToCurrentProject({pick: pick, role: role})
    },
    getRating(profile) {
      if (profile.rating) {
        let created = profile.rating.toString();
        if (!created || !created.length || created.length < 14)
          return 0;

        let rating = Math.min(10, parseInt(created.slice(0, created.length - 13)));

        return rating / 2;
      }

      return 0;
    },
    async setRating(profile, val) {
      val = 2 * val;
      let updateValue = 0
      if (!profile.rating)
        profile.rating = Date.now();

      let created = profile.rating.toString();
      if (created.length < 14)
        updateValue = parseInt(val.toString() + created);
      else
        updateValue = parseInt(val.toString() + created.slice(created.length - 13));
      profile.rating = updateValue;
      
      if (profile.approveState != 'approved') {
        profile.approveState = 'approved';
        await api.updateActorApprovalState('approved', profile.userId);
      }
      await api.updateActorRating(updateValue, profile.userId);
    },
    async declineProfile(profile) {
      profile.approveState = 'declined';
      await api.updateActorApprovalState('declined', profile.userId);
    },
    imageLoadError(event, item, i) {
      // remove item from items at index i
      this.items.splice(i, 1);
    }
  },
}
</script>